import React from 'react';
import PropTypes from 'prop-types';

import {
    MAX_CHANGELOG_LENGTH,
    FIELD_VALIDATION_ERROR_TYPES,
} from '../../../utils/constants';

import Caption from '../../Caption/Caption';
import EditLabelError from '../EditLabelError/EditLabelError';
import Textarea from '../../Textarea/Textarea';

import {
    FIELD_MAX_LIMIT_EXCEED_ERROR,
} from '../../../translations';

import {
    EDIT_CHANGELOG_LABEL,
    EDIT_CHANGELOG_CURRENT_LABEL,
} from './translations';

import styles from './EditChangelog.module.css';

export default class EditChangelog extends React.PureComponent {
    static propTypes = {
        externalError: PropTypes.oneOf([
            FIELD_VALIDATION_ERROR_TYPES.MAX_LIMIT,
        ]),
        externalValue: PropTypes.string,
        isDisabled: PropTypes.bool,
        isSecondary: PropTypes.bool,

        onValueChange: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.state = {
            errorType: null,
            value: '',
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.externalValue && nextProps.externalValue !== this.state.value) {
            this.setState({
                value: nextProps.externalValue,
            })
        }
    }

    handleValueChange = (value) => {
        let errorType = null

        if (value.length > MAX_CHANGELOG_LENGTH) {
            errorType = FIELD_VALIDATION_ERROR_TYPES.MAX_LIMIT
        }

        this.setState({ errorType, value })
        this.props.onValueChange(value, errorType)
    }

    renderError() {
        const errorToMessagesMapping = {
            [FIELD_VALIDATION_ERROR_TYPES.MAX_LIMIT]: FIELD_MAX_LIMIT_EXCEED_ERROR(MAX_CHANGELOG_LENGTH),
        }
        return this.state.errorType ? (
            <EditLabelError message={errorToMessagesMapping[this.state.errorType]} />
        ) : null
    }

    render() {
        return (
            <div className={styles.base}>
                <div className={styles.label}>
                    <Caption
                        isLarge={!this.props.isSecondary}
                        isError={!!this.props.externalError}>
                        {this.props.isSecondary ? EDIT_CHANGELOG_LABEL : EDIT_CHANGELOG_CURRENT_LABEL}
                    </Caption>
                    {this.renderError()}
                </div>
                <div className={styles.field}>
                    <Textarea
                        value={this.state.value}
                        isDisabled={this.props.isDisabled}
                        isError={!!this.props.externalError}
                        onChange={this.handleValueChange}
                    />
                </div>
            </div>
        )
    }
}
